/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-03-25 15:11:41
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 09:26:20
 * @FilePath: \qrcode-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home",
		component: HomeView
	},
	{
		path: "/about",
		name: "about",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/AboutView.vue")
	},
	{
		path: "/codeVr",
		name: "codeVr",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/codeVr.vue")
	},
	{
		path: "/login",
		name: "login",
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/login.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
